import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { Iconify } from '@/shared/components/iconify';

import { ActiveSessionsPanel } from './active-sessions-panel';

interface SessionsViewProps {
  onBack: () => void;
  /** Mobile drill-down already shows the title + back button in the dialog
   *  header — hide this view's inline breadcrumb to avoid duplication. */
  isMobile?: boolean;
}

// Sub-view (mounted by SettingsDialog) that hosts a standalone Sessions page.
// Mirrors the breadcrumb pattern used by ChangePasswordView.
export function SessionsView({ onBack, isMobile = false }: SessionsViewProps) {
  const { t } = useTranslation('settings');

  return (
    <Box>
      {!isMobile && (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
          <Link
            component="button"
            type="button"
            onClick={onBack}
            sx={{
              fontSize: 14,
              fontWeight: 500,
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': { color: 'text.primary' },
            }}
          >
            {t('account.changePassword.breadcrumbAccount')}
          </Link>
          <Box
            sx={(theme) => ({
              color: 'text.disabled',
              display: 'inline-flex',
              transform: theme.direction === 'rtl' ? 'scaleX(-1)' : 'none',
            })}
          >
            <Iconify icon="eva:arrow-ios-forward-fill" width={14} />
          </Box>
          <Iconify icon="solar:monitor-bold" width={20} />
          <Typography
            component="h2"
            sx={{
              fontFamily: '"Cairo Variable", sans-serif',
              fontSize: 18,
              fontWeight: 700,
              color: 'text.primary',
              letterSpacing: '-0.01em',
            }}
          >
            {t('account.sessions.title')}
          </Typography>
        </Stack>
      )}

      <Typography sx={{ fontSize: 13.5, color: 'text.secondary', mb: 3, maxWidth: 560 }}>
        {t('account.sessions.subtitle')}
      </Typography>

      <ActiveSessionsPanel hideFootnote />
    </Box>
  );
}
